import {baseApi} from "./base-api";
import {getPagedResponse, PagedResponse} from "../../../utils/helpers";
import { buildPagedResponseTags} from "../../../utils/api-utils";
import {WorkOrderNotification} from "../../data/entities/work-order-notification";


export const notificationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    
    GetWorkOrdersNotifications: build.query<PagedResponse<WorkOrderNotification>, Record<string, any>>({
      query: (params) => ({
        url: `notification/getWorkOrdersNotifications`,
        params
      }),
      transformResponse: getPagedResponse,
      providesTags: (result) => buildPagedResponseTags(result, 'WorkOrderAsset')
    }),
    InitialNotifications: build.query<any, string>({
      query: (userId) => ({
        url: `notification/InitialNotifications/${userId}`,
        method: 'GET',
      }),
    }),
    markAsRead: build.mutation<WorkOrderNotification, { notificationId: string }>({
      query: (dto) => ({
        url: `notification/markAsRead/${dto.notificationId}`,
        method: 'POST',
        body: dto
      }),
    }),
    
  }),
  overrideExisting: true,
});

export const {
  useLazyGetWorkOrdersNotificationsQuery,
  useMarkAsReadMutation,
  useLazyInitialNotificationsQuery,

} = notificationsApi;
